import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import * as layoutConstants from '../constants/layout';

// All layouts/containers
import DefaultLayout from '../layouts/Default';
import VerticalLayout from '../layouts/Vertical';
import DetachedLayout from '../layouts/Detached';
import HorizontalLayout from '../layouts/Horizontal';

import {
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
} from './index';
import ErrorPageNotFoundAlt from '../pages/error/PageNotFoundAlt';
import { SignalRProvider } from '../providers/SignalRProvider';

const Routes = (props: any) => {
  const { layout } = useSelector((state: any) => ({ layout: state.Layout }));
  const validUser = localStorage.getItem('validUser');

  if (
    (!validUser || validUser !== 'active') &&
    window.location.pathname !== '/' &&
    window.location.pathname !== '/account/logout' &&
    window.location.pathname !== '/pudo/check-access' &&
    window.location.pathname !== '/pudo/registration' &&
    window.location.pathname !== '/redirect-app'
  ) {
    window.location.href = window.location.origin;
  }

  const getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (layout.layoutType) {
      case layoutConstants.LAYOUT_HORIZONTAL:
        layoutCls = HorizontalLayout;
        break;
      case layoutConstants.LAYOUT_DETACHED:
        layoutCls = DetachedLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  let Layout = getLayout();

  return (
    <BrowserRouter>
      <Switch>
        <Route path={authProtectedFlattenRoutes.map((r) => r['path'])}>
          <SignalRProvider>
            <Layout {...props} layout={layout}>
              <Switch>
                {authProtectedFlattenRoutes.map((route, index) => {
                  return (
                    !route.children && (
                      <route.route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={route.component}
                      />
                    )
                  );
                })}
              </Switch>
            </Layout>
          </SignalRProvider>
        </Route>

        <Route path={publicProtectedFlattenRoutes.map((r) => r['path'])}>
          <DefaultLayout {...props} layout={layout}>
            <Switch>
              {publicProtectedFlattenRoutes.map((route, index) => {
                return (
                  !route.children && (
                    <route.route
                      key={index}
                      path={route.path}
                      exact={route.exact}
                      component={route.component}
                    />
                  )
                );
              })}
            </Switch>
          </DefaultLayout>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;

